<template>
    <div class="page-wrapper">
      <div class="page-title">
        <CIcon name="cil-chart" /> Monthly Data Histogram
      </div>

        <CRow>
            <CCol md="12">
                <data-filter
                    :tableLength="totalRecords"
                    v-model="filter"
                    :monthly="true"
                ></data-filter>
            </CCol>
        </CRow>
        <div v-if="loading" class="loader-area">
            <pulse-loader :loading="loading" color="#2E7D32"></pulse-loader>
        </div>
        
        <CRow v-if="!loading">            
            <CCol md="12">                
                <CCard>
                    <CCardHeader class="no-backdrop">
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <span class="card-title mb-0">Monthly Data Histogram</span>
                            <div class="small text-danger" v-if="displacementData.length == 0">No records found for applied filters!</div>
                        </div>
                    </CCardHeader>
                    <CCardBody v-if="displacementData && displacementData.length > 0">
                        <apexchart type="bar" :options="histogram.chartOptions" :series="histogram.series"></apexchart>            
                    </CCardBody>
                    <CCardBody v-else-if="!loading">
                        <p class="text-center text-muted mb-0">No data available for the selected filters.</p>
                    </CCardBody>
                </CCard>

            </CCol>            
        </CRow>
    </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import axios from 'axios';
import store from '../../store';
import JsonExcel from 'vue-json-excel';
import DataFilter from '../components/dataFilter.vue';


export default {
    name : 'Monthly',
    components: {
        DataFilter,
        PulseLoader,
        JsonExcel,
    },
    props : {
        small : true,
        
    },
    data() {
        return {
            baseURL : store.state.baseURL,
            filename : 'SaveAnimals_Data.xls',
            showFilter : false,

            histogram : {
                percentage : [],
                values: [],
                chartOptions: {
                    chart: {
                        type: 'bar',
                        height : 600
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: false,
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        formatter : this.graphLabel,
                    },
                    xaxis: {
                        categories: [],
                        labels: {
                            style: {
                                fontSize: '14px'
                            }
                        }
                    }
                },
          
            },

            selected : {},
            filter : {
                fromDate : null,
                toDate : null,
                class : null,
                family : null,
                group : null,
                identity : null,
                scientific : null,
                zone : null,
                outcome : null,
                date : null,
                timeType : 'admission',
                timeIntervalType : 'year',
                caseno : null,
                stage : null,
                facility : null,
                placeOfRescue : null,
                causeOfDisp : null
            },
            graphColours : [
                '#e6194B', 
                '#3cb44b', 
                '#ffe119', 
                '#4363d8', 
                '#f58231', 
                '#911eb4', 
                '#42d4f4', 
                '#f032e6', 
                '#bfef45', 
                '#808000'
            ],
            perPage: 12,
            currentPage: 1,
            loading : true,
            filterLoading : true,
            fields : [         
            ],
            download : [],
            totalRecords : 0,
            loadPage : 1,
            pagesAvailable : 1,           
        }
    },
    beforeMount(){
        var d = new Date();
        var str = d.toISOString();
        str = str.substr(0, 10);
        str = str.replace(/-/g, '');
        this.filename = 'SaveAnimals_Data_'+ str +'.xls';
    },
    created() {
        this.selected = {
            date : store.state.filters.date,
            startDate : store.state.filters.startDate,
            endDate : store.state.filters.endDate,
            outcome : store.state.filters.outcome,
            zone : store.state.filters.zone,
            class : store.state.filters.class,
            family : store.state.filters.family,
            group : store.state.filters.group,
            identity : store.state.filters.identity,
            caseno : store.state.filters.caseno,
            scientific : store.state.filters.scientific,
            stage : store.state.filters.stage,
            facility : store.state.filters.facility,
            placeOfRescue : store.state.filters.placeOfRescue,
            causeOfDisp : store.state.filters.causeOfDisp,
            month : store.state.filters.month,
            year : store.state.filters.year,
        }


        this.filter = {
            fromDate : this.selected.startDate,
            toDate : this.selected.endDate,
            class : this.selected.class,
            family: this.selected.family,
            group : this.selected.group,
            identity : this.selected.identity,
            scientific : this.selected.scientific,
            zone : this.selected.zone,
            outcome : this.selected.outcome,
            timeType : this.selected.sourceType,
            date : this.selected.date,
            timeIntervalType : this.selected.sourceIntervalType,
            caseno : this.selected.caseno,
            stage : this.selected.stage,
            facility : this.selected.facility,
            placeOfRescue : this.selected.placeOfRescue,
            causeOfDisp : this.selected.causeOfDisp
        } 
        // this.getRecords(true);
    },
    watch : {
        filter : function(newVal, oldVal){
            this.getRecords(true);
        }
    },
    methods: {
        graphLabel(val, opts){
            return (val);
        },    
        getRecords(reset){
            this.loading = true;
            this.filter.timeIntervalType = "year";
            this.filter.timeType = "admission";
            axios({
                url : this.baseURL + "analytics/monthly-analysis",
                headers : {
                    authorization : store.state.token
                },
                data : this.filter,
                method : "POST"
            })
            .then(res => {
                if(res.data.status)
                {         

                    this.histogram.series = []
                    this.histogram.chartOptions.xaxis.categories = [];
                    this.histogram.values       = [];

                    // this.fields = res.data.fields;
                    this.displacementData = ['',''];

                    this.histogram.series.push(
                        {
                            data : res.data.histogram.series
                        }
                    )
                    this.histogram.chartOptions.xaxis.categories = (res.data.histogram.xaxis || []).map(cat => (!cat || cat === 'null') ? 'Unknown' : cat);
                    // this.histogram.values       = res.data.histogram.series;

                    this.totalRecords               = res.data.histogram.totalRecords

                    this.loading = false; 

                                  
                }
                else
                {
                    this.fields = [];
                    this.displacementData = [];
                    this.$notify({
                        group   : 'notification',
                        type    : 'error',
                        title   : 'Important message',
                        text    : res.data.message
                    });
                    this.loading = false;  
                }
            })
            .catch(err => {
                console.log(err);
                this.fields = [];
                this.displacementData = [];
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: err.status
                });
                this.loading = false;  
            });  

        },
        onSelectRow(row){
            this.openReport(row[0]._id);

        },
        selectAnimal(item){
        },
        openReport(id){
            window.open(`/existing-case/${id}`, '_blank');
            // this.$router.push({name : 'Conflict Report', params : { surveyid }});
        }
    }
}
</script>

<style scoped>
    .pad-r-0 {
        padding-right: 0px !important;
    }
    .pad-l-0 {
        padding-left: 0px !important;
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>